import React, { FC } from "react";
import { List, Spin } from "antd";
import moment from "moment";

import CommonService from "../../services/common.service";
import { IInstrumentExtended } from "../../models/instrument-extended.model";

interface ILabel {
  name: string;
  label: string;
  render?: (item: any) => string;
}

interface IProps {
  data: IInstrumentExtended;
  loading: boolean;
}

const InstrumentInfo: FC<IProps> = ({ data, loading }) => {
  const labels: ILabel[] = [
    {
      name: "percentChange24H",
      label: "1 day change",
      render: (name) => `${getValue(name)} %`,
    },
    {
      name: "percentChange7D",
      label: "7 days change",
      render: (name) => `${getValue(name)} %`,
    },
    {
      name: "percentChange30D",
      label: "30 days change",
      render: (name) => `${getValue(name)} %`,
    },
    {
      name: "percentChange1Y",
      label: "1 year change",
      render: (name) => `${getValue(name)} %`,
    },
    {
      name: "marketCapitalization",
      label: "Market Capitalization",
    },
    {
      name: "volume24H",
      label: "Volume 24h USD",
    },
    {
      name: "totalSupply",
      label: "Total Supply",
    },
    {
      name: "maxSupply",
      label: "Max Supply",
    },
    {
      name: "algorithm",
      label: "Algorithm",
    },
    {
      name: "proofType",
      label: "Proof Type",
    },
    {
      name: "updatedOn",
      label: "Update on",
      render: (name) => moment(getValue(name)).format("LLL"),
    },
  ];

  const getValue = (name: string) =>
    CommonService.toLocalNum(CommonService.getProperty(data, name));

  return (
    <Spin spinning={loading}>
      <h1 className="fs-36">${CommonService.toLocalNum(data.priceUsd)}</h1>
      <List
        dataSource={data ? labels : []}
        renderItem={(item: ILabel) => (
          <List.Item>
            <div className="d-flex align-items-center justify-content-between w-100">
              <span>{item.label}</span>
              <span>
                {item?.render ? item.render(item.name) : getValue(item.name)}
              </span>
            </div>
          </List.Item>
        )}
      />
    </Spin>
  );
};

export default InstrumentInfo;
